/**
 * Created by lk on 17/6/4.
 */
import axios from "axios";
import https from "../../utils/http";
import { getToken, getAdminId } from "../../utils/auth";
let http = https.https;

// 谁最懂我相关

// 列表
export function adSiteList(query) {
    let querys = JSON.parse(JSON.stringify(query));
    querys.ADMIN_ID = getAdminId();
    querys.ADMIN_TOKEN = getToken();
    return axios({
        url: http + "/ad/site/index",
        method: "get",
        params: querys
    });
}

// 广告列表
export function adSiteAdList(query) {
    let querys = JSON.parse(JSON.stringify(query));
    querys.ADMIN_ID = getAdminId();
    querys.ADMIN_TOKEN = getToken();
    return axios({
        url: http + "/ad/site/adList",
        method: "get",
        params: querys
    });
}

// 保存
export function adSiteSave(data, formName, method = "post") {
    let querys = JSON.parse(JSON.stringify(data));
    querys.ADMIN_ID = getAdminId();
    querys.ADMIN_TOKEN = getToken();
    var url =
        formName === "add" ? http + "/ad/site/save" : http + "/ad/site/edit";
    return axios({
        url: url,
        method: method,
        data: querys
    });
}

// 删除
export function adSiteDelete(data) {
    let querys = JSON.parse(JSON.stringify(data));
    querys.ADMIN_ID = getAdminId();
    querys.ADMIN_TOKEN = getToken();
    return axios({
        url: "/admin/ad/site/delete",
        method: "post",
        data: querys
    });
}
